export const colors = {
  yellow : '#FECA17',
  darkGrey : '#2B2B2B'
};


export const dimensions = {
  contentWidth : 1440
};
